import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import FranchiseTable from '../../../../components/Table/FranchiseTable';
import Year from '../../../../shared/Year';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';

const FranchiseInfo: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');

  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  return (
    searchParam.get('selectedYear') && (
      <>
        <Year setSelectedYear={setSelectedYear} noPadding />
        <FranchiseTable selectedYear={selectedYear} isConfigurator={true} />
      </>
    )
  );
};

export default FranchiseInfo;
